module.exports = __webpack_public_path__ + "img/content_voice_1.8eb4a605.png";